import { shallowMemoize } from '@sail/utils';
import createGlobalizeWithLocale from '../../internal/createGlobalizeWithLocale/createGlobalizeWithLocale';
import getCldrDisplayNameValue from '../../internal/display-name-formatter/getCldrDisplayNameValue';
import mergeOptions from '../../internal/mergeOptions';
const displayNameFormatter = shallowMemoize((config, locale, type, reports)=>{
    const globalize = createGlobalizeWithLocale(config, locale, undefined, reports);
    return (value)=>{
        if (!value) {
            return '';
        }
        return getCldrDisplayNameValue(globalize, type, value, reports);
    };
});
/**
 * @see https://sail.stripe.me/apis/intl/useIntl/#format-display-name
 */ export default function formatDisplayName(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, /**
   * - If the type is `"region"`, `code` should be:
   *   - For countries: a [two-letter ISO 3166 code](https://www.iso.org/iso-3166-country-codes.html).
   *   - For continents and subcontinents: a [three-digit UN M49 code](https://unstats.un.org/unsd/methodology/m49/).
   * - If the type is `"language"`, `code` should be:
   *   - A [BCP 47 language tag](https://www.rfc-editor.org/rfc/rfc5646.html#section-2).
   *   - A two-letter [ISO 639-1 language code](https://www.iso.org/standard/22109.html).
   *   - A three-letter [ISO 639-2 language code](https://www.iso.org/standard/4767.html) in case a two letter code doesn't exist.
   * - If the type is `"currency"`, `code` should be:
   *   - A three-letter [ISO 4217 currency code](https://www.iso.org/iso-4217-currency-codes.html).
   *   - A non-ISO currency code like `USDC` for USD Coin or `BTC` for Bitcoin.
   */ code, /** An object with options to customize the formatting. */ options) {
    const defaults = {
        locale: config.locale
    };
    const mergedOptions = mergeOptions(config, defaults, reports, options);
    const formatter = displayNameFormatter(config, mergedOptions.locale, mergedOptions.type, reports);
    return formatter(code);
}

//# sourceMappingURL=formatDisplayName.js.map